import React from "react";

export default function BookMark(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="12.158" height="16.5" viewBox="0 0 12.158 16.5">
			<path
				id="ic_turned_in_not_24px"
				d="M15.421,3H6.737A1.735,1.735,0,0,0,5.009,4.737L5,19.5l6.079-5.211L17.158,19.5V4.737A1.742,1.742,0,0,0,15.421,3Zm0,13.026L11.079,12.4l-4.342,3.63V4.737h8.684Z"
				transform="translate(-5 -3)"
				fill="#142541"
			/>
		</svg>
	);
}

export function BookMarkLg() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="24.5" viewBox="0 0 18.053 24.5">
			<path
				id="ic_turned_in_not_24px"
				d="M20.474,3H7.579A2.576,2.576,0,0,0,5.013,5.579L5,27.5l9.026-7.737L23.053,27.5V5.579A2.587,2.587,0,0,0,20.474,3Zm0,19.342-6.447-5.39-6.447,5.39V5.579H20.474Z"
				transform="translate(-5 -3)"
				fill="#83909B"
				// stroke="#83909b"
			/>
		</svg>
	);
}
